import React from 'react';
import { CopyOutlined } from '@ant-design/icons';
import messages from 'i18n/messages/home';
import { RibbonButton } from 'common/components';
import { useGlobalModal } from 'hooks';

function ProductClone({ isDisabled }) {
  const { openModal, MODAL_NAMES } = useGlobalModal();

  return (
    <>
      <RibbonButton
        size='small'
        icon={<CopyOutlined style={{ height: 26 }} />}
        label={messages.productClone}
        onClick={() => openModal(MODAL_NAMES.COPY_PRODUCT_MODAL)}
        disabled={isDisabled}
        className='button-item-dropdown'
      />
    </>
  );
}

export default ProductClone;
